<template>
  <div>
    <AddTag class="tag" @updateTags="setTagsFilter" />
    <VideoPreview ref="video" class="video" :src="src" />
    <SongEditor
      class="edit"
      ref="songEditor"
      @save="save"
      @play="play"
      @changeVideo="changeVideo"
    />
    <div v-if="showLoader" class="load"><Loader class="loader" /></div>
    <div v-if="showComplete" class="complete">
      <p>保存が完了しました</p>
      <button @click="reload">OK</button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import AddTag from "@/components/AddTag.vue";
import VideoPreview from "@/components/VideoPreview.vue";
import SongEditor from "@/components/SongEditor.vue";
import Loader from "@/components/Loader.vue";
import firebase from "@/firebase/firebase";
import { v4 as uuidv4 } from "uuid";

export default defineComponent({
  name: "CreateSongsData",
  components: { AddTag, VideoPreview, SongEditor, Loader },
  setup() {
    const _sleep = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms));
    return {
      _sleep,
      src: ref(""),
      showComplete: ref(false),
      showLoader: ref(false),
    };
  },
  methods: {
    play(start: number) {
      console.log("createsongdata", start);
      const tmp: any = this.$refs.video;
      console.log(start);
      tmp.jumpAt(start);
      tmp.play();
    },
    changeVideo(url: string) {
      console.log("createsongsdata", url);
      this.src = url;
    },
    save: async function (songs: any) {
      console.log(songs);
      const user: any = firebase.auth().currentUser;
      let uid: string = user.uid;
      if (uid == null) uid = "unknown";
      this.showLoader = true;
      const db = firebase.firestore();
      let ok = true;
      songs.forEach((song: any) => {
        db.collection("songs")
          .doc(uuidv4())
          .set({
            screenTitle: song.screenTitle,
            start: song.start,
            end: song.end,
            videoId: song.videoId,
            tag: song.tags,
            authorId: uid,
          })
          .then(() => {
            console.log("add success");
          })
          .catch((err: Error) => {
            console.log("add failed");
            alert(err);
            ok = false;
          });
      });

      this.showLoader = false;
      if (ok) this.showComplete = true;
    },
    setTagsFilter() {
      const tmp: any = this.$refs.songEditor;
      tmp.setTagsFilter();
    },
    reload() {
      this.src = "";
      const tmp: any = this.$refs.songEditor;
      console.log(tmp);
      tmp.reload();
      this.showComplete = false;
      this.showLoader = false;
    },
  },
});
</script>

<style scoped>
.tag {
  width: 25%;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 50px;
  border: solid;
  padding-top: 10px;
}
.video {
  width: 25%;
  position: fixed;
  border: solid;
  padding-top: 10px;
  left: 0;
  bottom: 0;
  top: 50px;
}
.edit {
  width: 50%;
  padding: 10px;
  margin: auto;
}
.complete {
  position: fixed;
  right: 40%;
  left: 40%;
  top: 40%;
  bottom: 40%;
  background-color: white;
  padding: 30px;
}
.load {
  position: fixed;
  z-index: 100;
  right: 0%;
  left: 0%;
  top: 0%;
  bottom: 0%;
  background-color: black;
  opacity: 30%;
}
.loader {
  position: fixed;
  margin: auto;
  top: 100px;
}
</style>
